import {useSelector} from "react-redux";
import {useCallback, useEffect} from "react";

const FONT_RESIZE_CLASSNAME_SUFFIX = "fontSizeAdjustor-";

export function useFontResize(ref) {
  const { selectedSize } = useSelector(
    (state) => state.fontSizeAdjustor,
  );

  const handleFontResize = useCallback(
    (root, size) => {
      if (!root) return;
      const contentRoot = root.querySelector("#contentId");

      if (contentRoot) {
        Array.from(contentRoot.classList).forEach(className => {
          if (className.startsWith(FONT_RESIZE_CLASSNAME_SUFFIX)) {
            contentRoot.classList.remove(className);
          }
        });
        contentRoot.classList.add(`${FONT_RESIZE_CLASSNAME_SUFFIX}${size}`);
      }
    },
    [],
  );

  useEffect(() => {
    if (ref?.current) {
      handleFontResize(ref.current, selectedSize);
    }
  }, [ref, selectedSize]);
}